import { useBookmarkQueueQuery } from "graphql/generated";
import { useContentDetailModal } from "hooks/useContentDetailModal";

interface UpNextCardProps {
    userId: string;
}

// ─── 홈피드 상단에 표시되는 "다음 읽을 콘텐츠" 카드 ───────────────────────────
// 큐의 첫 번째 아이템을 보여주고, 클릭 시 큐 전체를 네비게이션 목록으로 모달 오픈
export const UpNextCard = ({ userId }: UpNextCardProps) => {
    const { data, loading } = useBookmarkQueueQuery({
        variables: { userId },
        fetchPolicy: "cache-and-network"
    });

    const { openContentModal } = useContentDetailModal();

    const queueItems = data?.mix_content_bookmark ?? [];
    const topItem = queueItems[0];

    if (loading || !topItem) return null;

    const content = topItem.mix_content;
    const queueCount = queueItems.length;

    // 큐 전체를 네비게이션 목록으로 모달 오픈
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        openContentModal(
            content.id,
            queueItems.map((item) => item.mix_content),
            "bookmark"
        );
    };

    return (
        <button
            onClick={handleClick}
            className="group mb-4 flex w-full items-center gap-3 rounded-xl
                bg-white px-4 py-3 text-left shadow-md transition-shadow
                hover:shadow-lg dark:bg-[#171717] lg:mb-0"
        >
            {/* 큐 카운트 배지 */}
            <div
                className="bg-secondary-main/10 flex h-9 w-9 shrink-0 flex-col
                    items-center justify-center rounded-lg"
            >
                <span
                    className="text-base font-bold leading-none
                        text-secondary-main"
                >
                    {queueCount}
                </span>
                <span
                    className="text-secondary-main/70 mt-0.5 w-max text-[9px]
                        leading-none"
                >
                    나중에 볼 글
                </span>
            </div>

            {/* 썸네일 */}
            {content.imgurl && (
                <div
                    className="bg-bg-secondary h-10 w-10 shrink-0
                        overflow-hidden rounded-md"
                >
                    <img
                        src={content.imgurl}
                        alt=""
                        className="h-full w-full object-cover"
                    />
                </div>
            )}

            {/* 제목 + 출처 */}
            <div className="min-w-0 flex-1">
                <p
                    className="truncate text-sm font-medium text-text-primary
                        group-hover:text-secondary-main"
                >
                    {content.title}
                </p>
                {content.source && (
                    <p className="mt-0.5 truncate text-xs text-text-secondary">
                        {content.source}
                    </p>
                )}
            </div>

            {/* 화살표 */}
            <svg
                className="shrink-0 text-text-placeholder"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
            >
                <path d="M3 7h8M8 4l3 3-3 3" />
            </svg>
        </button>
    );
};
